import { required, requiredIf } from 'vuelidate/lib/validators'
import Fileupload from '@/components/common/fileupload/Fileupload.vue'
import EmailTemplateParams from '@/components/configs/emails/templateparams/EmailTemplateParams.vue'

const defaultEl = {
  id: null,
  code: '',
  title: {},
  message: {},
  template_id: null,
  files: []
};

export default {
  name: 'EmailEditMessage',
  data () {
    return {
      editEl: defaultEl,
      loading: false,
      elname: 'messages',
      templateOptions: []
    }
  },
  components: {
    EmailTemplateParams,
    Fileupload
  },
  validations: {
    editEl: {
      code: { required },
      title: { required },
      message: { required },
      files: {
        $each: {
          file: {
            required: requiredIf(function (el) {
              return (el && !el.filename);
            })
          }
        }
      }
    }
  },
  computed: {
    getTitle () {
      if (this.editEl.id) {
        return this.$t('menu.config.emails.' + this.elname + '.edit');
      }
      return this.$t('menu.config.emails.' + this.elname + '.new');
    }
  },
  methods: {
    getTemplates () {
      const self = this;
      this.ApiRequest.request('config/emails/templates', this.ApiRequest.REQUEST_GET, { full: true }, function (response) {
        if (response.data) {
          const options = Object.values(response.data.items);
          options.unshift({ code: '', id: null });
          self.templateOptions = options;
        }
      });
    },
    show (elData) {
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      this.$v.$reset();
      this.$refs['modal-window'].show();
    },
    save () {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        const reqData = this.ApiRequest.createFormData(this.editEl, Object.keys(defaultEl), 'message', this);
        const self = this;
        this.ApiRequest.request('config/emails/edit/' + self.elname, this.ApiRequest.REQUEST_FILEUPLOAD, reqData, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self, { 'item.code': 'general.item.code' });
          } else {
            self.$emit('saved', response.data);
            self.close();
          }
          self.loading = false;
        });
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    },
    downloadfile (key) {
      this.editEl.files[key].loading = true;
      this.$refs.fileupload.forceUpdate(key);
      const self = this;
      this.ApiRequest.request('config/emails/download/' + this.editEl.files[key].id, this.ApiRequest.REQUEST_DOWNLOAD, [], function () {
        self.editEl.files[key].loading = false;
        self.$refs.fileupload.forceUpdate(key);
      });
    }
  },
  mounted () {
    this.getTemplates();
  }
}
